/** Dev: empty → same origin + webpack proxy. Prod: full API URL from build env. */
export const apiBaseUrl = (process.env.API_BASE_URL as string) || '';
